import { API_ROOT } from '@/static/api';

export const MAINTENANCE_STATUS_URL = `${API_ROOT}/api/status`;

const DEFAULT_POLL_SECONDS = 30;

const listeners = new Set();

/**
 * The API's maintenance body as page props, or null when the body says the
 * app is up or is not the contract at all (an HTML page from `artisan down
 * --render`, a proxy error).
 * @returns {{message: string, retryAfter: ?number}|null}
 */
export const readMaintenance = (body) => {
    if (!body || body.status !== 'maintenance') {
        return null;
    }
    return { message: body.message || undefined, retryAfter: body.retry_after ?? null };
};

export const maintenanceFromError = (error) => {
    const response = error && error.response;
    return response && response.status === 503 ? readMaintenance(response.data) : null;
};

export const pollDelayMs = (retryAfter) => (Number(retryAfter) > 0 ? Number(retryAfter) : DEFAULT_POLL_SECONDS) * 1000;

/**
 * Resolves the maintenance details while the API is down and null while it is
 * up. Rejects when the endpoint cannot be read, so callers can tell "unknown"
 * from "up".
 */
export const fetchMaintenanceStatus = async (fetchImpl = fetch) => {
    const response = await fetchImpl(MAINTENANCE_STATUS_URL, { headers: { Accept: 'application/json' } });
    const body = await response.json();
    if (!body || (body.status !== 'up' && body.status !== 'maintenance')) {
        throw new Error(`Unexpected status response (HTTP ${response.status})`);
    }
    return readMaintenance(body);
};

export const reportMaintenance = (maintenance) => {
    listeners.forEach((listener) => listener(maintenance));
};

export const onMaintenance = (listener) => {
    listeners.add(listener);
    return () => listeners.delete(listener);
};
